import { Fragment, useEffect, useState } from 'react';
import { useConfig } from '../ConfigProvider';
import configDefault from '../config/config-default';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const UNIT_KEYS = ['days', 'hours', 'minutes', 'seconds'];

const getUnits = (difference) => [
    Math.floor(difference / DAY),
    Math.floor((difference / HOUR) % 24),
    Math.floor((difference / MINUTE) % 60),
    Math.floor((difference / SECOND) % 60),
];

// flexDirection explicite : le CSS global met les div en colonne par défaut
const rowStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' };
const columnStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', minWidth: '5rem' };
const digitStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '16px', height: '28px', fontSize: '1.875rem', fontWeight: 800 };

export default function Countdown({ targetDate }) {
    const clubCountdown = useConfig().plans?.countdown;
    const { title, endedText } = { ...configDefault.plans.countdown, ...clubCountdown };
    const labels = { ...configDefault.plans.countdown.labels, ...clubCountdown?.labels };
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), SECOND);
        return () => clearInterval(interval);
    }, []);

    const difference = new Date(targetDate).getTime() - now;
    const isRunning = difference > 0;

    return (
        <div className='countdown' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem 1rem 2rem' }}>
            {isRunning ? (
                <>
                    <p style={{ fontWeight: 700, textAlign: 'center', textTransform: 'uppercase', marginBottom: '1rem' }}>
                        {title}
                    </p>
                    <div style={rowStyle}>
                        {getUnits(difference).map((value, index) => (
                            <Fragment key={UNIT_KEYS[index]}>
                                {index > 0 && <span style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '1.5rem' }}>:</span>}
                                <div style={columnStyle}>
                                    <div style={{ ...rowStyle, gap: '2px' }}>
                                        {String(value).padStart(2, '0').split('').map((digit, digitIndex) => (
                                            <span key={digitIndex} style={digitStyle}>{digit}</span>
                                        ))}
                                    </div>
                                    <span style={{ fontSize: '0.875rem', fontWeight: 500, textTransform: 'uppercase', marginTop: '0.25rem' }}>{labels[UNIT_KEYS[index]]}</span>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </>
            ) : (
                <p style={{ fontWeight: 600, textAlign: 'center' }}>{endedText}</p>
            )}
        </div>
    );
}
